import { render, staticRenderFns } from "./SelectRegionRestricted.vue?vue&type=template&id=5843254e&"
import script from "./SelectRegionRestricted.vue?vue&type=script&lang=js&"
export * from "./SelectRegionRestricted.vue?vue&type=script&lang=js&"
import style0 from "./SelectRegionRestricted.vue?vue&type=style&index=0&id=5843254e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports